import * as React from 'react'
import { SVGProps } from 'react'

const SvgInterestCompoundedDaily = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 281 180"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity={0.3}
      d="M170.67 129.697c29.575-27.606 56.034-68.832 25.644-104.228-27.564-32.125-78.222-23.282-93.828 18.705-6.736 18.11 1.967 35.747-7.774 53.231-9.74 17.484-30.85 32.901-15.674 54.896 23.502 34.061 72.178-4.434 91.632-22.604Z"
      fill="#C2FFE7"
    />
    <path
      stroke="#000"
      strokeWidth={2}
      strokeLinecap="round"
      d="M262.5 166h-244M18.5 22v144"
    />
    <path
      fill="#33DC98"
      d="M34.5 133h30v32h-30zM84.5 126h30v39h-30zM134.5 114h30v51h-30zM184.5 99h30v66h-30zM234.5 78h30v87h-30z"
    />
    <path
      d="M49.824 114.357S190.244 92.691 246.413 30M246.5 30v11M246.5 30h-11"
      stroke="#33DC98"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
)

export default SvgInterestCompoundedDaily
